import React from "react";
import ReactModal from "react-modal";
import defer from "lodash/defer";
import classNames from "classnames";
import cuid from "uuid";
import Button from "../../elements/button/Button";
import { focusFirstElement } from "../../utils/focusUtils";
import TEXT from "./TEXT";
function getAppElement() {
    return document.getElementById("js-bodyContainer") || document.body;
}
function createDialogTitleId(id) {
    return `dialog-title-${id}`;
}
const InternalDialogHeader = (props) => {
    const closeButton = props.showCloseButton ? (React.createElement(Button, { icon: "dialog-close", iconOnly: true, aria: { label: TEXT.closeDialog(props.title) }, disabled: !props.isCloseable, onClick: () => props.onRequestClose(), className: "gui-dialog__closeButton gui-button--whiteOutline gui-button--transparent" }, "Lukk dialog")) : null;
    const headerClassnames = classNames("gui-dialog__header", {
        "gui-dialog__header--shortened": props.shortenText,
        "gui-dialog__header--padForCloseButton": props.showCloseButton
    });
    return (React.createElement("header", { className: headerClassnames },
        React.createElement("strong", { className: "gui-dialog__title", id: props.titleId, tabIndex: -1, "aria-label": TEXT.dialogTitleAriaLabel(props.title) }, props.title),
        closeButton));
};
const InternalDialogFooter = (props) => (React.createElement("footer", { className: "gui-dialog__footer" }, props.footer));
class Dialog extends React.Component {
    constructor(props) {
        super(props);
        this.dialogContent = null;
        this.dialogId = cuid();
        this.handleOnRequestClose = this.handleOnRequestClose.bind(this);
        this.setFocusOnContent = this.setFocusOnContent.bind(this);
        this.setFocusOnTitle = this.setFocusOnTitle.bind(this);
        this.handleOnAfterOpen = this.handleOnAfterOpen.bind(this);
        this.dialogClosed = this.dialogClosed.bind(this);
        this.dialogOpened = this.dialogOpened.bind(this);
    }
    setFocusOnContent() {
        focusFirstElement(this.dialogContent);
    }
    setFocusOnTitle() {
        const title = document.getElementById(createDialogTitleId(this.dialogId));
        if (title) {
            title.focus();
        }
        else {
            this.dialogWrapper.focus();
        }
    }
    componentDidUpdate(prevProps) {
        if (!this.props.isOpen && prevProps.isOpen) {
            this.dialogClosed();
        }
        else if (this.props.isOpen && !prevProps.isOpen) {
            this.dialogOpened();
        }
    }
    // Denne kjøres dersom komponent fjernes fra DOM uten å bli lukket
    componentWillUnmount() {
        if (this.props.isOpen) {
            this.dialogClosed();
        }
    }
    // Denne må kjøres dersom komponent legges til og allerede er åpen
    componentDidMount() {
        if (this.props.isOpen) {
            this.dialogOpened();
        }
    }
    dialogClosed() {
        if (this.dialogTrigger) {
            this.dialogTrigger.focus();
        }
        else if (this.props.dialogTrigger && typeof this.props.dialogTrigger === "string") {
            const domElement = document.getElementById(this.props.dialogTrigger);
            if (domElement) {
                domElement.focus();
            }
        }
        else if (this.props.dialogTrigger && this.props.dialogTrigger instanceof HTMLElement) {
            this.props.dialogTrigger.focus();
        }
        this.dialogTrigger = null;
    }
    dialogOpened() {
        this.dialogTrigger = document.activeElement;
    }
    handleOnRequestClose() {
        if (this.props.isCloseable) {
            this.props.onRequestClose();
        }
    }
    handleOnAfterOpen() {
        defer(() => {
            if (this.props.focusOnContent) {
                this.setFocusOnContent();
            }
            else {
                this.setFocusOnTitle();
            }
        });
    }
    render() {
        const titleId = createDialogTitleId(this.dialogId);
        const className = classNames("gui-dialog", `gui-dialog--${this.props.style}`, {
            "gui-dialog--noHeader": !this.props.showHeader,
            "gui-dialog--aboveDialog": this.props.showAboveDialog
        });
        const overlayClassName = classNames("gui-overlay", this.props.customOverlayClassName ? this.props.customOverlayClassName : "", {
            "gui-overlay--aboveDialog": this.props.showAboveDialog
        });
        const bodyClassname = classNames("gui-dialog__body", {
            "gui-dialog__body--noPadding": !this.props.hasPadding
        });
        return (React.createElement(ReactModal, { isOpen: this.props.isOpen, contentLabel: this.props.title, className: className, overlayClassName: overlayClassName, onRequestClose: this.handleOnRequestClose, shouldCloseOnOverlayClick: this.props.shouldCloseOnOverlayClick && this.props.isCloseable, onAfterOpen: this.handleOnAfterOpen, appElement: getAppElement(), ariaHideApp: true, ref: (c) => (this.dialogWrapper = c) },
            this.props.showHeader ? (React.createElement(InternalDialogHeader, Object.assign({}, this.props, { onRequestClose: this.handleOnRequestClose, titleId: titleId }))) : null,
            React.createElement("div", { ref: c => (this.dialogContent = c), className: "gui-dialog__contentWrapper" },
                React.createElement("div", { className: bodyClassname }, this.props.children),
                this.props.footer ? React.createElement(InternalDialogFooter, Object.assign({}, this.props)) : null)));
    }
}
Dialog.defaultProps = {
    isOpen: false,
    isCloseable: true,
    showHeader: true,
    showCloseButton: true,
    style: "normal",
    focusOnContent: false,
    hasPadding: true,
    shouldCloseOnOverlayClick: true
};
export default Dialog;
//# sourceMappingURL=Dialog.js.map